export const pointMarker= [
    {
        lng: 120.20987,
        lat: 28.802473,
        title: "缙云县先锋工具有限公司",
        text: "浙江省丽水市缙云县聚贤路272号",
        
        url:require("../../static/logoimg/pos.png")
    }
]